// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as checkoutSuccessStepActions } from '../duck';
import CheckoutSuccessStep from '../components/CheckoutSuccessStep';
import { push } from 'react-router-redux';

import type { RootState } from '../../../../index';

function mapStateToProps(state: RootState) {
  return {
    order: state.newOrder.checkoutSuccessStep.order,
    fetchOrderError: state.newOrder.checkoutSuccessStep.fetchOrderError,
    isFetchingOrder: state.newOrder.checkoutSuccessStep.isFetchingOrder,
    locale: state.locale,
    localValues: state.localValues,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...checkoutSuccessStepActions,
    goToRedirect: (route: string) => push(route),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutSuccessStep);



// WEBPACK FOOTER //
// ./src/modules/new-order/CheckoutSuccessStep/containers/CheckoutSuccessContainer.jsx